export const TricolorStripe = ({ className = "" }) => {
  return (
    <div className={`flex w-full ${className}`} aria-hidden="true">
      <div className="flex-1 h-[3px] bg-[#009246]" />
      <div className="flex-1 h-[3px] bg-white" />
      <div className="flex-1 h-[3px] bg-[#CE2B37]" />
    </div>
  );
};

export const TricolorStripeMini = ({ width = "40px", className = "" }) => {
  return (
    <div className={`flex ${className}`} style={{ width }} aria-hidden="true">
      <div className="flex-1 h-[3px] bg-[#009246]" />
      <div className="flex-1 h-[3px] bg-white" />
      <div className="flex-1 h-[3px] bg-[#CE2B37]" />
    </div>
  );
};
